import { blogCategories, blogPosts } from '../assets/siteData';
import { Section } from '../components/Section';

export function BlogPage() {
  return (
    <Section
      eyebrow="Blog & Learning"
      title="Thoughts on programming, robotics, books, and practical growth"
      description="A clean editorial layout that supports authority-building and learning-led trust."
    >
      <div className="filter-row filter-row--compact">
        {blogCategories.map((item) => (
          <span className="filter-chip filter-chip--static" key={item}>
            {item}
          </span>
        ))}
      </div>

      <div className="blog-grid">
        {blogPosts.map((post) => (
          <article className="blog-card glass-panel" key={post.title}>
            <div className="blog-card__meta">
              <span className="tag">{post.category}</span>
              <span>{post.meta}</span>
            </div>
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
          </article>
        ))}
      </div>
    </Section>
  );
}
